<template>
  <ContentView>
    <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <b-modal
        v-model="isModalActive"
        has-modal-card
        trap-focus
        scroll="keep"
        aria-role="dialog"
        aria-label="AskForProjectCreationModal"
        :aria-modal="true"
        class="AskForProjectCreationView"
        @close="cancelProjectCreation"
      >
        <div class="modal-card">
          <header class="modal-card-head">
            <H3TitleView class="modal-card-title"
              >{{ $t("myProjects.create-project.title").toString() }}
            </H3TitleView>
            <button
              type="button"
              class="delete"
              aria-label="close"
              @click="cancelProjectCreation"
            ></button>
          </header>
          <section class="modal-card-body">
            <SingleEtablissement :etablissement="chosenEtablissement" />
            <div class="AskForProjectCreationView-infos">
              <b-icon icon="times-circle" type="is-danger" />
              <span>
                {{ $t("myProjects.create-project.etablissementWithProject-condition") }}
              </span>
            </div>
            <div>
              <span>
                {{ $t("myProjects.create-project.etablissementWithProject1") }}
              </span>
              <br />
              <br />
              <span>{{ $t("myProjects.create-project.etablissementWithProject2") }}</span>
              <br />
              <br />
              <span>{{ $t("myProjects.create-project.etablissementWithProject4") }}</span>
            </div>
            <InputWithValidation
              v-model="projectName"
              rules="required"
              :label="$t('myProjects.create-project.name')"
              class="AskForProjectCreationView-name"
              :maxlength="150"
              vid="AskForProjectCreationView-nomProjet"
            />
          </section>
          <footer class="modal-card-foot">
            <div :class="`buttons ${isReferent ? 'hasPreviousStep' : ''}`">
              <b-button v-if="isReferent" rounded type="is-primary" @click="goPrevious">
                {{ $t("myProjects.previousStep") }}
              </b-button>
              <div class="modal-finish-buttons">
                <div class="hoverable-discrete-link" @click="cancelProjectCreation">
                  {{ $t("annuler") }}
                </div>
                <b-button rounded type="is-primary" @click="handleSubmit(askForCreation)">
                  {{ $t("myProjects.create-project.create") }}
                </b-button>
              </div>
            </div>
          </footer>
        </div>
      </b-modal>
    </ValidationObserver>
  </ContentView>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import ContentView from "@/views/commons/ContentView.vue"
import H3TitleView from "@/views/commons/H3TitleView.vue"
import { EtablissementDTO, ProjetAnnuelDTO, UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import { PROFIL_UTILISATEUR } from "@/model/bean/EnumHelper"
import SingleEtablissement from "../organisme/SingleEtablissement.vue"
import InputWithValidation from "../inputs/InputWithValidation.vue"
import ValidationObserver from "@/services/validation/ValidationObserver.vue"
import { BButton, BIcon, BModal } from "buefy"

export default defineComponent({
  name: "AskForProjectCreationView",
  components: {
    ContentView,
    H3TitleView,
    SingleEtablissement,
    InputWithValidation,
    ValidationObserver,
    BButton,
    BIcon,
    BModal,
  },
  props: {
    loggedUser: {
      type: Object as PropType<UtilisateurDTO>,
      required: true,
    },
    projectsInEtablissement: {
      type: Array as PropType<ProjetAnnuelDTO[]>,
      required: true,
    },
    chosenEtablissement: {
      type: Object as PropType<EtablissementDTO>,
      required: true,
    },
  },

  emits: ["ask-project-creation", "cancel-project-creation"],
  data() {
    return {
      isReferent: false,
      projectName: "",
      projectDescription: "",
      isModalActive: true,
    }
  },
  mounted() {
    this.isModalActive = true
  },
  created(): void {
    if (!this.projectsInEtablissement || this.projectsInEtablissement.length === 0) {
      this.$router.push("/myProjects")
    }
    this.isReferent = this.loggedUser.profil === PROFIL_UTILISATEUR.REFERENT
  },
  methods: {
    askForCreation(): void {
      this.$emit("ask-project-creation", this.projectName, this.projectDescription)
    },

    cancelProjectCreation(): void {
      this.$emit("cancel-project-creation")
    },

    goPrevious(): void {
      this.$router.push("/myProjects/new")
    },
  },
})
</script>

<style lang="scss" scoped>
@import "@/styles/variables";

.AskForProjectCreationView {
  .modal-card {
    height: $create-project-modals-height;
    overflow-y: auto !important;
  }
}

.AskForProjectCreationView-infos {
  font-weight: 700;
  margin: 0.25rem 0;
  display: flex;
  align-items: center;
}

.AskForProjectCreationView-cards {
  display: flex;
  align-items: center;

  .BookmarkCard {
    margin-left: 0.5rem;
  }
}

.AskForProjectCreationView-name {
  .InputWithValidation-field {
    margin-top: 2rem;
  }
}
</style>
